// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2tn1X","ThumbZoom":"ChapterPlayer_ThumbZoom__oBlpb"};